import { useEffect, useState } from "react";
import { useFetch } from "../../../custom/api";
import LoadingComp from "../../../components/LoadingComp";
import UserRankRow from "./UserRankRow";
import UserProfilePreviewModal from "../../../components/UserProfilePreviewModal";
import "../../../styles/Challenges.css";

function Leaderboard({ challengeId, refreshKey }) {
  const { myFetch } = useFetch();
  const [entries, setEntries] = useState(null);
  const [total, setTotal] = useState(0);
  const [myRank, setMyRank] = useState(null);
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [previewUser, setPreviewUser] = useState(null);

  const loadPage = async (nextPage) => {
    const resp = await myFetch(`challenges/${challengeId}/leaderboard?page=${nextPage}`, {
      method: "GET",
    });
    const r = await resp.json();
    setMyRank(r.my_rank || null);
    setTotal(r.total || 0);
    setEntries((prev) => (nextPage === 1 || !prev ? r.entries : [...prev, ...r.entries]));
    setPage(nextPage);
  };

  useEffect(() => {
    loadPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [challengeId, refreshKey]);

  if (entries === null) return <LoadingComp />;

  if (entries.length === 0) {
    return <p className="caption-1 grey-2 centerAlign marginTop5 yekan">هنوز کسی این چالش رو شروع نکرده. اولین نفر باش!</p>;
  }

  const meIsVisible = entries.some((e) => e.is_me);
  const hasMore = entries.length < total;

  return (
    <div>
      {entries.map((entry) => (
        <UserRankRow key={entry.user_id} entry={entry} onOpenProfile={setPreviewUser} />
      ))}

      {hasMore && (
        <button
          type="button"
          className="challengeCheckinSecondary width100 marginTop5"
          disabled={loadingMore}
          onClick={async () => {
            setLoadingMore(true);
            await loadPage(page + 1);
            setLoadingMore(false);
          }}
        >
          {loadingMore ? "در حال بارگذاری..." : "نمایش بیشتر"}
        </button>
      )}

      {myRank && !meIsVisible && (
        <UserRankRow
          sticky
          entry={{
            rank: myRank.rank,
            points: myRank.points,
            name: "شما",
            is_me: true,
            completion_percentage: 0,
            user_id: "me",
          }}
          onOpenProfile={setPreviewUser}
        />
      )}

      <UserProfilePreviewModal
        show={!!previewUser}
        onClose={() => setPreviewUser(null)}
        userId={previewUser?.user_id}
        name={previewUser?.name}
      />
    </div>
  );
}

export default Leaderboard;
